/* unplugin-vue-components disabled */import script from "./ProductAssembly.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductAssembly.vue?vue&type=script&lang=ts&setup=true"

import "./ProductAssembly.vue?vue&type=style&index=0&id=2d9fb9c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9fb9c4"]])

export default __exports__